export const BUSINESS_CASE_TYPES = ['SELLING', 'BUYING'] as const;
